import { HTTP, HTTPS, MAILTO, TEL } from '../../constants';
import isAbsolutePath from './is-absolute-path';

const shouldUseStandardAnchor = url => {
  if (!url) return false;

  return (
    isAbsolutePath(url) ||
    url.startsWith(HTTP) ||
    url.startsWith(HTTPS) ||
    url.startsWith(MAILTO) ||
    url.startsWith(TEL)
  );
};

export default shouldUseStandardAnchor;
